"use client"

import { ReactNode } from "react"
import MenuHero from "@/components/menu-hero"
import CategoriesSection from "@/components/categories-section"
import BeveragesSection from "@/components/beverages-section"
import Footer from "@/components/footer"
import OrderStatusModal from "@/components/order-status-modal"
import OrderCompletionModal from "@/components/order-completion-modal"
import ConnectionStatus from "@/components/connection-status"
import NotificationContainer from "@/components/notification-container"
import FloatingNav from "@/components/floating-nav"
import BuffetAd from "@/components/buffet-ad"
import { useApp } from "@/lib/context"

interface MenuTemplateProps {
  isLoading?: boolean
  onLoadingComplete?: () => void
}

export default function DefaultMenu({ isLoading = false, onLoadingComplete }: MenuTemplateProps) {
  const { categoriesBebidas } = useApp()

  return (
    <main className="min-h-screen bg-background text-foreground">
      <MenuHero />
      <BuffetAd />
      <CategoriesSection />

      {categoriesBebidas.length > 0 ? (
        <div>
          <BeveragesSection />
        </div>
      ) : null}

      <Footer />

      {/* Modais e overlays partilhados */}
      <OrderStatusModal />
      <OrderCompletionModal />
      <NotificationContainer />
      <ConnectionStatus />
      <FloatingNav />
    </main>
  )
}
